import React from "react";

import Box from "../Box";

const Flex = ({ sx, ...otherProps }) => (
  <Box sx={{ display: "flex", ...sx }} {...otherProps} />
);

export default Flex;
